(() => {
  const minLabeledSide = 120;

  const imageSize = (image) => {
    const width = Number.parseInt(image.getAttribute('width') || '', 10) || image.clientWidth || 0;
    const height = Number.parseInt(image.getAttribute('height') || '', 10) || image.clientHeight || 0;

    return { width, height };
  };

  const mediaFrameFor = (image) => image.closest('picture') || image.parentElement;

  const isProductGalleryImage = (image) =>
    image.closest('.custom-product-280k__gallery, .custom-leaf-hero__gallery, .product__media-wrapper, .product__media, media-gallery, [data-gallery-thumbs]') ||
    image.hasAttribute('data-gallery-media');

  const clearLazyState = (image) => {
    const frame = mediaFrameFor(image);
    image.classList.remove('miaepic-lazy-image', 'miaepic-lazy-media', 'is-loading');
    if (!frame) return;
    frame.classList.remove('miaepic-lazy-media', 'miaepic-lazy-media--labeled', 'is-loading', 'has-error');
    delete frame.dataset.loadingLabel;
  };

  const markLoaded = (image, frame) => {
    frame.classList.remove('is-loading');
    frame.classList.add('is-loaded');
    image.classList.add('is-loaded');
  };

  const bindImage = (image) => {
    if (image.dataset.lazyMediaBound === 'true') return;

    if (isProductGalleryImage(image)) {
      image.dataset.lazyMediaBound = 'true';
      clearLazyState(image);
      return;
    }

    const frame = mediaFrameFor(image);
    if (!frame) return;

    const { width, height } = imageSize(image);
    const isLargeMedia = width >= minLabeledSide || height >= minLabeledSide;

    image.dataset.lazyMediaBound = 'true';

    if (!isLargeMedia) return;

    image.classList.add('miaepic-lazy-image');
    frame.classList.add('miaepic-lazy-media', 'miaepic-lazy-media--labeled');
    frame.dataset.loadingLabel = frame.dataset.loadingLabel || 'Loading image';

    if (image.complete && image.naturalWidth > 0) {
      markLoaded(image, frame);
      return;
    }

    frame.classList.add('is-loading');
    image.addEventListener('load', () => markLoaded(image, frame), { once: true });
    image.addEventListener('error', () => {
      frame.classList.remove('is-loading');
      frame.classList.add('has-error');
    }, { once: true });
  };

  const bindLazyImages = (root = document) => {
    root.querySelectorAll('img[loading="lazy"]').forEach(bindImage);
  };

  const currentScript = document.currentScript;
  const deferOnMobile = currentScript?.dataset.deferMobile === 'true' && window.matchMedia('(max-width: 749px)').matches;

  const initializeLazyImages = () => {
    bindLazyImages();
    document.addEventListener('shopify:section:load', (event) => bindLazyImages(event.target));
  };

  if (deferOnMobile) {
    const scheduleInitialization = () => {
      const scheduleIdle = window.requestIdleCallback || ((callback) => window.setTimeout(callback, 600));
      scheduleIdle(initializeLazyImages, { timeout: 2000 });
    };

    if (document.readyState === 'complete') {
      scheduleInitialization();
    } else {
      window.addEventListener('load', scheduleInitialization, { once: true, passive: true });
    }
  } else {
    initializeLazyImages();
  }
})();
